interface ErrorJson {
  error_code: string;
  error_message: string;
}
export default class BridgeError extends Error {
  code: string;

  constructor(code: string, message: string) {
    super(message);
    this.code = code;
  }

  public toJson(): Record<string, any> {
    return { error_code: this.code, error_message: this.message };
  }

  public static isError(data: Record<string, any>): boolean {
    return !!(data.error_code && data.error_message);
  }

  public static from(data: Record<string, any>): BridgeError | undefined {
    if (data.error_code && data.error_message) {
      const errorJson = data as ErrorJson;
      return new BridgeError(errorJson.error_code, errorJson.error_message);
    }
    return undefined;
  }
}
